<div class="mx-auto md:max-w-[867px]">
  <div class="py-6 flex flex-col gap-6">
    @if (download) {
      <div class="px-6 md:px-0 flex flex-col gap-4">
        <a
          #backLink
          [routerLink]="backLinkUrl"
          mat-button
          color="light"
          class="max-w-fit"
          (click)="selectDownload(download)"
        >
          <mat-icon svgIcon="sli-pfeil-links-20" aria-hidden="true"></mat-icon>
          {{ backLinkLabel }}
        </a>

        <h1 class="mu-heading-3 md:mu-heading-2 text-petrol-650">
          {{ download.displayTitle }}
        </h1>
      </div>

      <mat-card
        class="flex flex-col gap-6 w-full rounded-none md:rounded-lg p-6"
      >
        @if (
          hasProductGroupLabel(download) && download.productGroupLabel !== ''
        ) {
          <div class="pb-3">
            <mat-chip>
              <span class="text-xs">{{ download.productGroupLabel }}</span>
            </mat-chip>
          </div>
        }

        <download-info-card
          [downloadInformation]="download"
          [showTeaser]="false"
          [enableHorizontalDisplay]="true"
        ></download-info-card>
        @if (shouldDisplayDetailView$ | ngrxPush) {
          <dp-product-doc-view
            [source]="download.details ? download.details : ''"
          ></dp-product-doc-view>
        }
      </mat-card>
    } @else {
      <div class="flex justify-center px-6">
        <mat-card class="max-w-screen-sm">
          <dackl-empty-state image="no-matches" size="XXS">
            <h2 class="heading-3 mb-2">Download nicht gefunden</h2>
            <p>
              Der gewünschte Download wurde nicht gefunden. Bitte suchen Sie
              einen anderen Download aus den bereitgestellten Listen aus.
            </p>

            <a actions mat-button color="primary" [routerLink]="backLinkUrl">
              Anderen Download wählen
            </a>
          </dackl-empty-state>
        </mat-card>
      </div>
    }
  </div>
</div>
